import React from "react"
import {motion} from "framer-motion";

function QuestionSvg(props) {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             className='fill-current-'>
            <path
                d="M12.5 0C5.883 0 0.5 5.383 0.5 12C0.5 18.617 5.883 24 12.5 24C19.117 24 24.5 18.617 24.5 12C24.5 5.383 19.117 0 12.5 0ZM12 19C11.172 19 10.5 18.328 10.5 17.5C10.5 16.672 11.172 16 12 16C12.828 16 13.5 16.672 13.5 17.5C13.5 18.328 12.828 19 12 19ZM16.311 10.127C16.002 10.622 15.415 11.178 14.549 11.796C13.148 12.832 13.186 13.062 13.186 14H10.729C10.729 13.267 10.713 12.704 11.109 12.019C11.362 11.58 11.826 11.113 12.5 10.619C13.309 10.041 14.095 9.484 14.095 8.514C14.095 7.605 13.317 7.281 12.408 7.281C11.481 7.281 10.424 7.584 9.237 8.19L8.226 6.16C10.383 4.951 13.787 4.404 15.648 5.919C17.014 7.032 17.022 8.989 16.311 10.127Z"
                fill="white"/>
        </svg>
    )
}

function CarouselArrowRight(props) {
    return (
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 18L10 10L2 2" stroke="white" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

function CarouselArrowLeft(props) {
    return (
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2L2 10L10 18" stroke="white" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

function SwiperArrowRight(props) {
    return (
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 18L10 10L2 2" stroke="#AC8243" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

function SwiperArrowLeft(props) {
    return (
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2L2 10L10 18" stroke="#AC8243" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

function Alarm(props) {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.2135 15.4017C17.2258 13.7693 16.6921 11.9028 16.6676 9.99501V6.67167C16.6676 4.90356 15.9653 3.20787 14.715 1.95763C13.4648 0.707384 11.7691 0.00500488 10.001 0.00500488C8.23287 0.00500488 6.53718 0.707384 5.28694 1.95763C4.0367 3.20787 3.33432 4.90356 3.33432 6.67167V9.99001C3.31074 11.8995 2.77703 13.7679 1.78849 15.4017C1.71196 15.528 1.6704 15.6725 1.66807 15.8202C1.66574 15.9679 1.70272 16.1136 1.77522 16.2423C1.84772 16.371 1.95313 16.4781 2.08066 16.5527C2.20819 16.6273 2.35325 16.6666 2.50098 16.6667H17.501C17.6487 16.6666 17.7938 16.6273 17.9213 16.5527C18.0488 16.4781 18.1542 16.371 18.2267 16.2423C18.2992 16.1136 18.3362 15.9679 18.3339 15.8202C18.3316 15.6725 18.29 15.528 18.2135 15.4017Z"
                fill="#AC8243"/>
            <path
                d="M10.8407 19.8542C11.1899 19.7298 11.5071 19.5292 11.7693 19.267C12.0315 19.0048 12.232 18.6876 12.3565 18.3384H7.64648C7.75668 18.6476 7.92671 18.9322 8.14687 19.1757C8.36704 19.4193 8.63301 19.6171 8.92962 19.7578C9.22623 19.8986 9.54766 19.9796 9.87555 19.9961C10.2034 20.0126 10.5314 19.9644 10.8407 19.8542Z"
                fill="#AC8243"/>
        </svg>

    )
}

function ArrowCatUp(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="m8 14 4-4 4 4"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgArrowCatDown(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="m16 10-4 4-4-4"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function ArrowDown(props) {
    return (
        <svg
            width={18}
            height={10}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="m1 1 8 8 8-8"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgArrowSmLeft1(props) {
    return (
        <svg
            width={48}
            height={48}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={48} height={48} rx={24} fill="#095191"/>
            <path
                d="m28 32-8-8 8-8"
                stroke="#fff"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function ArrowDownDropdown(props) {
    return (
        <svg
            width={20}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="m2 2 8 8 8-8"
                stroke="#AC8243"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgBMeeting(props) {
    return (
        <svg
            width={48}
            height={48}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M46 2H22v21l9-7h15V2ZM20 43.672c0-1.208-.529-2.357-1.476-3.108C17.078 39.416 14.57 38 11 38s-6.078 1.416-7.524 2.564C2.529 41.315 2 42.464 2 43.672V46h18v-2.328ZM11 33a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM46 43.672c0-1.208-.529-2.357-1.476-3.108C43.078 39.416 40.57 38 37 38s-6.078 1.416-7.524 2.564c-.947.751-1.476 1.9-1.476 3.108V46h18v-2.328ZM37 33a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgCalendarGrid(fill) {
    return (
        <svg
            width={20}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#calendar-grid-61_2_svg__a)" fill={fill}>
                <path
                    d="M15.833 3V1.333a.833.833 0 1 0-1.667 0V3h1.667ZM5.833 3V1.333a.833.833 0 0 0-1.667 0V3h1.667ZM17.5 19.667h-15a2.5 2.5 0 0 1-2.5-2.5V6.333a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v10.834a2.5 2.5 0 0 1-2.5 2.5ZM18.333 8H1.667v9.167A.833.833 0 0 0 2.5 18h15a.833.833 0 0 0 .833-.833V8Z"/>
                <path
                    d="M6.667 9.667H3.334v2.5h3.333v-2.5ZM11.667 9.667H8.334v2.5h3.333v-2.5ZM6.667 13.833H3.334v2.5h3.333v-2.5ZM11.667 13.833H8.334v2.5h3.333v-2.5ZM16.667 9.667h-3.333v2.5h3.333v-2.5Z"/>
            </g>
        </svg>
    )
}

function SvgDiagTopRight(props) {
    return (
        <svg
            width={12}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1 11 11 1M6 1h5v5"
                stroke="#095191"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgDropDownSelected(props) {
    return (
        <svg
            width={32}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M16 0a16 16 0 1 0 16 16A16.047 16.047 0 0 0 16 0Zm-2.667 23.219L6.115 16 8 14.115l5.333 5.333L24 8.781l1.885 1.886-12.552 12.552Z"
                fill="#AC8243"
            />
        </svg>
    )
}

function SvgEventTicket(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M23 10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1c1.103 0 2 .897 2 2s-.897 2-2 2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1c-1.103 0-2-.897-2-2s.897-2 2-2Zm-6 5H7v-2h10v2Zm0-4H7V9h10v2Z"
                fill="#fff"
            />
        </svg>
    )
}

function SvgEventTicketmb(props) {
    return (
        <svg
            width={16}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.333 7.167A.666.666 0 0 0 16 6.5V3.167a.666.666 0 0 0-.667-.667H.667A.666.666 0 0 0 0 3.167V6.5c0 .369.298.667.667.667C1.402 7.167 2 7.765 2 8.5S1.402 9.833.667 9.833A.666.666 0 0 0 0 10.5v3.333c0 .369.298.667.667.667h14.666a.666.666 0 0 0 .667-.667V10.5a.666.666 0 0 0-.667-.667A1.335 1.335 0 0 1 14 8.5c0-.735.598-1.333 1.333-1.333Zm-4 3.333H4.667V9.167h6.666V10.5Zm0-2.667H4.667V6.5h6.666v1.333Z"
                fill="#fff"
            />
        </svg>
    )
}

function SvgEventTicketSm(props) {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M19.167 8.333c.46 0 .833-.372.833-.833V3.333a.833.833 0 0 0-.833-.833H.833A.833.833 0 0 0 0 3.333V7.5c0 .46.372.833.833.833.92 0 1.667.748 1.667 1.667 0 .92-.748 1.667-1.667 1.667A.833.833 0 0 0 0 12.5v4.167c0 .46.372.833.833.833h18.334c.46 0 .833-.372.833-.833V12.5a.833.833 0 0 0-.833-.833c-.92 0-1.667-.748-1.667-1.667 0-.92.747-1.667 1.667-1.667Zm-5 4.167H5.833v-1.667h8.334V12.5Zm0-3.333H5.833V7.5h8.334v1.667Z"
                fill="#fff"
            />
        </svg>
    )
}

function SvgFrame(props) {
    return (
        <svg
            width={48}
            height={48}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={48} height={48} rx={24} fill="#095191"/>
            <path
                d="M13 24h22M13 17h22M24 31h11"
                stroke="#fff"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgFurnishedProperty(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#furnished-property_svg__a)" fill="#fff">
                <path
                    d="M9.916 6.777a.5.5 0 0 0 .046-.469l-2.5-6A.5.5 0 0 0 7 0H3a.5.5 0 0 0-.462.308l-2.5 6A.5.5 0 0 0 .5 7h9a.5.5 0 0 0 .416-.223ZM13 14.869V16h6v-1a2.936 2.936 0 0 1 2.869-3H22v-2a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v2a2.936 2.936 0 0 1 3 2.869Z"/>
                <path
                    d="M23 14h-1a1 1 0 0 0-1 1v3H11v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1v1a1 1 0 0 0 2 0v-1h8v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1ZM4 23a1 1 0 1 0 2 0V9H4v14Z"/>
            </g>
            <defs>
                <clipPath id="furnished-property_svg__a">
                    <path fill="#fff" d="M0 0h24v24H0z"/>
                </clipPath>
            </defs>
        </svg>
    )
}

function SvgHamburgerIcon(props) {
    return (
        <svg
            width={48}
            height={48}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={48} height={48} rx={24} fill="#fff"/>
            <path
                d="M13 24h22M13 17h22M24 31h11"
                stroke="#AC8243"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgInfo(props) {
    return (
        <svg
            width={25}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12.5 0C5.883 0 .5 5.383.5 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12ZM12 19a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 12 19Zm4.311-8.873c-.309.495-.896 1.051-1.762 1.669-1.401 1.036-1.363 1.266-1.363 2.204h-2.457c0-.733-.016-1.296.38-1.981.253-.439.717-.906 1.391-1.4.809-.578 1.595-1.135 1.595-2.105 0-.909-.778-1.233-1.687-1.233-.927 0-1.984.303-3.171.909L8.226 6.16c2.157-1.209 5.561-1.756 7.422-.241 1.366 1.113 1.374 3.07.663 4.208Z"
                fill={props.fill}
            />
        </svg>
    )
}

function SvgLeftArrow(fill, stroke) {
    return (
        <svg
            width={32}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x={32}
                width={32}
                height={32}
                rx={16}
                transform="rotate(90 32 0)"
                fill={fill}
            />
            <path
                d="m20 8-8 8 8 8"
                stroke={stroke}
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgLock(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M19 11H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Z"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 7V6a4.95 4.95 0 0 0-4.9-5H12a4.95 4.95 0 0 0-5 4.9V7"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgLogout(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#logout_svg__a)" fill="#AC8243">
                <path
                    d="M17 22H5V2h12v2h2V1a.946.946 0 0 0-1-1H4a.945.945 0 0 0-1 1v22a.945.945 0 0 0 1 1h14a.945.945 0 0 0 1-1v-3h-2v2Z"/>
                <path d="m22 12-7-6v5H8v2h7v5l7-6Z"/>
            </g>
            <defs>
                <clipPath id="logout_svg__a">
                    <path fill="#fff" d="M0 0h24v24H0z"/>
                </clipPath>
            </defs>
        </svg>
    )
}

function SvgMaskMob(props) {
    return (
        <svg
            width={101}
            height={100}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                opacity={0.25}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.376 16.68 21.767 4.785a2 2 0 0 1 .685-.246L49.429.124c.845-.138 1.688.275 2.053 1.05 2.02 4.283 5.277 13.244 6.758 24.456.218 1.65-1.651 2.756-3.29 2.464-2.345-.417-4.071.531-5.676 1.6-2.288 1.527-4.824 6.515-6.405 10.636-1.583 1.377-3.19 2.584-4.586 3.28-2.688 1.34-7.264 1.013-10.873.371-1.016-.18-1.684 1.059-.877 1.701 3.343 2.661 8.006 5.436 12.189 5.468-1.075 3.161-2.119 6.765-2.857 10.66-.25 1.316-1.675 2.08-2.878 1.487C18.718 56.267 14.18 50.48 8.231 38.583c-4.36-8.72-6.8-16.1-7.765-19.772-.22-.835.165-1.697.91-2.131ZM54.22 35.152l24.537 7.774a2 2 0 0 1 .59.301L99.23 58.022a1.965 1.965 0 0 1 .624 2.403C92.034 77.274 72.262 106.43 50.32 98.71c-18.344-6.454-8.381-44.03 1.575-62.633a1.953 1.953 0 0 1 2.324-.924ZM42.33 19.078c-2.452.611-4.678 2.873-6.117 4.787-.729.968-.252 2.298.93 2.566 2.018.458 4.672.697 6.699-.186 2.112-.92 3.934-2.914 5.09-4.517.618-.858.303-2.022-.7-2.358-1.506-.505-3.643-.855-5.902-.292Zm-20.134 6.897c-2.452.611-4.679 2.873-6.118 4.787-.728.968-.251 2.298.93 2.566 2.019.458 4.673.697 6.7-.186 2.112-.92 3.933-2.914 5.089-4.517.619-.858.304-2.021-.7-2.358-1.506-.505-3.643-.855-5.901-.292Zm37.013 56.288c2.82 1.039 5.717 4.595 7.724 7.663.564.863 1.924.5 1.84-.527-.463-5.56-2.325-12.89-7.473-14.717-5.376-1.908-11.604 1.566-15.313 4.547-.714.574-.258 1.662.657 1.654 3.858-.032 9.413.219 12.565 1.38ZM52.576 56.48c2.38-.264 5.553-.193 7.678 1.174 1.958 1.259 3.168 3.055 3.833 4.498.442.96-.189 1.988-1.238 2.125-1.959.257-4.66.297-6.777-.61-2.032-.87-3.678-2.967-4.728-4.75-.614-1.045.027-2.303 1.232-2.437Zm18.822 9.934c2.38-.264 5.553-.193 7.678 1.174 1.958 1.259 3.168 3.055 3.833 4.498.443.96-.189 1.987-1.238 2.125-1.959.257-4.66.297-6.777-.61-2.032-.871-3.677-2.967-4.727-4.75-.615-1.045.026-2.304 1.231-2.437Z"
                fill="#202020"
            />
        </svg>
    )
}

function SvgMasks(props) {
    return (
        <svg
            width={192}
            height={192}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                opacity={0.25}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.249 32.567 41.681 8.982a2 2 0 0 1 .684-.246L95.587.026c.845-.138 1.682.268 2.063 1.035 3.995 8.05 11.26 27.377 13.948 51.661.183 1.654-1.661 2.782-3.187 2.117-6.395-2.785-10.584-.595-14.41 1.956-4.378 2.919-9.228 12.46-12.25 20.341-3.03 2.634-6.104 4.943-8.773 6.274-6.048 3.016-17.09 1.62-24.243.02-1.006-.225-1.7 1.006-.926 1.688 6.395 5.637 16.81 12.645 26.008 12.714-2.275 6.695-4.479 14.428-5.897 22.804-.224 1.322-1.65 2.085-2.858 1.504C36.017 108.198 27.18 97.154 15.5 73.795 6.617 56.03 1.901 41.175.322 34.697c-.204-.838.182-1.695.927-2.13Zm100.798 34.218 48.633 15.409c.212.067.411.17.59.302l39.449 29.346c.749.558 1.025 1.537.639 2.388-14.516 31.991-52.802 89.539-95.358 74.565-35.522-12.498-15.547-86.01 3.723-121.104.455-.829 1.423-1.191 2.324-.906ZM80.719 36.49c-5.447 1.358-10.313 6.974-12.911 10.858a1.75 1.75 0 0 0 .964 2.681c3.943 1.155 10.236 2.172 14.837.168 4.694-2.044 8.638-6.863 10.706-10.057.575-.888.265-2.052-.704-2.476-2.828-1.235-7.692-2.47-12.892-1.174Zm-38.51 13.191c-5.447 1.358-10.312 6.974-12.911 10.859a1.75 1.75 0 0 0 .964 2.68c3.943 1.156 10.236 2.173 14.838.169 4.694-2.045 8.637-6.864 10.705-10.058.575-.888.266-2.052-.704-2.475-2.828-1.236-7.692-2.47-12.892-1.175ZM113 157.34c6.342 2.336 12.893 11.334 16.631 17.639.526.887 1.897.548 1.864-.483-.352-10.784-3.519-27.762-14.495-31.656-11.22-3.982-24.378 4.291-31.102 10.223-.687.606-.218 1.703.698 1.679 7.284-.19 19.692.125 26.404 2.598Zm-14.756-49.025c4.61-.771 12.034-1.077 16.756 1.959 4.508 2.898 6.942 7.287 7.981 10.192.356.996-.279 2.02-1.32 2.21-3.743.683-9.955 1.115-14.661-.902-4.613-1.977-8.186-7.257-10.047-10.92a1.75 1.75 0 0 1 1.29-2.539Zm36 19c4.61-.771 12.034-1.077 16.756 1.959 4.508 2.898 6.942 7.287 7.981 10.192.356.996-.279 2.02-1.32 2.21-3.743.683-9.955 1.115-14.661-.902-4.613-1.977-8.186-7.257-10.047-10.92a1.75 1.75 0 0 1 1.291-2.539Z"
                fill="#202020"
            />
        </svg>
    )
}

function SvgMaskTablet(props) {
    return (
        <svg
            width={141}
            height={141}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                opacity={0.25}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.304 23.723 30.55 6.696a2 2 0 0 1 .684-.245L69.81.15c.845-.139 1.684.27 2.059 1.04 2.9 5.962 7.915 19.464 9.939 36.403.197 1.652-1.651 2.777-3.226 2.24-4.132-1.408-6.96.095-9.56 1.826-3.212 2.136-6.77 9.122-8.988 14.893-2.223 1.93-4.48 3.62-6.438 4.596-4.163 2.072-11.549 1.3-16.78.23-1.01-.207-1.695 1.028-.907 1.693 4.73 3.992 11.916 8.59 18.304 8.638-1.605 4.714-3.162 10.13-4.204 15.993-.235 1.319-1.658 2.08-2.864 1.497-20.798-10.064-27.238-18.16-35.72-35.092C5.076 41.435 1.629 30.784.384 25.858c-.212-.838.174-1.7.92-2.135Zm74.032 25.382 35.188 11.127c.212.066.411.168.589.3l28.529 21.182a1.96 1.96 0 0 1 .633 2.396c-10.783 23.501-38.735 65.114-69.785 54.21-25.936-9.107-11.55-62.458 2.524-88.303.452-.83 1.422-1.197 2.322-.912ZM59.276 26.79c-3.767.937-7.154 4.643-9.128 7.448-.697.991-.22 2.32.952 2.63 2.903.77 7.142 1.33 10.297-.04 3.244-1.411 6-4.624 7.577-6.948.594-.875.281-2.037-.704-2.423-2.119-.831-5.45-1.55-8.994-.667ZM31.02 36.45c-3.766.936-7.154 4.643-9.128 7.448-.697.99-.22 2.319.953 2.63 2.902.77 7.141 1.33 10.296-.041 3.245-1.41 6-4.624 7.577-6.947.594-.875.281-2.037-.704-2.424-2.119-.83-5.45-1.548-8.994-.667Zm51.943 78.835c4.366 1.606 8.866 7.505 11.67 12.041.543.877 1.91.527 1.855-.502-.42-7.906-2.878-19.425-10.59-22.157-7.949-2.815-17.222 2.735-22.293 7.031-.699.592-.234 1.686.682 1.669 5.41-.101 13.959.184 18.676 1.918ZM72.739 79.292c3.4-.488 8.425-.566 11.69 1.529 3.071 1.97 4.83 4.88 5.677 6.99.394.983-.24 2.008-1.284 2.176-2.776.447-7.01.646-10.262-.745-3.162-1.352-5.657-4.815-7.085-7.451-.578-1.067.064-2.326 1.264-2.499Zm26.412 13.914c3.4-.488 8.425-.567 11.691 1.528 3.07 1.97 4.83 4.881 5.676 6.99.394.983-.239 2.009-1.284 2.177-2.776.446-7.01.645-10.262-.746-3.162-1.352-5.657-4.814-7.085-7.45-.578-1.067.064-2.327 1.264-2.5Z"
                fill="#202020"
            />
        </svg>
    )
}

function SvgMinimalUp(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="m22 18.414-10-10-10 10L.586 17 11.293 6.293a.999.999 0 0 1 1.414 0L23.414 17 22 18.414Z"
                fill="#AC8243"
            />
        </svg>
    )
}

function SvgRightArrow(fill, stroke) {
    return (
        <svg
            width={32}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                y={32}
                width={32}
                height={32}
                rx={16}
                transform="rotate(-90 0 32)"
                fill={fill}
            />
            <path
                d="m12 24 8-8-8-8"
                stroke={stroke}
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgSearchIcon(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="m22.56 20.439-5.233-5.233a9.028 9.028 0 1 0-2.122 2.122l5.233 5.233a1.5 1.5 0 0 0 2.122-2.122ZM3 9.999a7 7 0 1 1 7 7A7.008 7.008 0 0 1 3 10Z"
                fill="#AC8243"
            />
        </svg>
    )
}

function SvgShop(fill) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21 5h-4c0-2.8-2.2-5-5-5S7 2.2 7 5H3c-.6 0-1 .4-1 1v17c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1Zm-9-3c1.7 0 3 1.3 3 3H9c0-1.7 1.3-3 3-3Z"
                fill={fill || '#fff'}
            />
        </svg>
    )
}

function SvgSimpleRemove1(props) {
    return (
        <svg
            width={48}
            height={48}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={48} height={48} rx={24} fill="#fff"/>
            <path
                d="M31.7 16.3c-.4-.4-1-.4-1.4 0L24 22.6l-6.3-6.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l6.3 6.3-6.3 6.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l6.3-6.3 6.3 6.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L25.4 24l6.3-6.3c.4-.4.4-1 0-1.4Z"
                fill="#AC8243"
            />
        </svg>
    )
}

function SvgSimpleRemove2(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M19.7 4.3c-.4-.4-1-.4-1.4 0L12 10.6 5.7 4.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l6.3 6.3-6.3 6.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l6.3-6.3 6.3 6.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L13.4 12l6.3-6.3c.4-.4.4-1 0-1.4Z"
                fill="#AC8243"
            />
        </svg>
    )
}

function SvgStar(props) {
    return (
        <svg
            width={32}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="m30.86 11.388-9.441-1.372-4.218-8.55a1.388 1.388 0 0 0-2.392 0l-4.225 8.55-9.441 1.372a1.334 1.334 0 0 0-.741 2.273l6.833 6.659-1.612 9.404a1.333 1.333 0 0 0 1.935 1.405l8.444-4.438 8.444 4.438a1.334 1.334 0 0 0 1.934-1.405l-1.612-9.404 6.834-6.659a1.334 1.334 0 0 0-.74-2.273h-.002Z"
                fill={props.color}
            />
        </svg>
    )
}

function SvgStarMobile(props) {
    return (
        <svg
            width={25}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M23.572 8.7 16.36 7.65l-3.222-6.53a1.06 1.06 0 0 0-1.827 0L8.083 7.65.871 8.7a1.019 1.019 0 0 0-.566 1.737l5.22 5.086-1.232 7.184a1.019 1.019 0 0 0 1.478 1.073l6.45-3.39 6.45 3.39a1.018 1.018 0 0 0 1.479-1.073l-1.232-7.184 5.22-5.086a1.018 1.018 0 0 0-.564-1.737h-.002Z"
                fill={props.color}
            />
        </svg>
    )
}

function SvgSucces() {
    return (
        <svg
            width={38}
            height={38}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19 0a19 19 0 1 0 19 19A19.055 19.055 0 0 0 19 0Zm-3.167 27.572L7.261 19 9.5 16.761l6.333 6.334L28.5 10.428l2.239 2.239-14.906 14.905Z"
                fill="#AC8243"
            />
        </svg>
    )
}

function SvgGroup(fill) {
    return (
        <svg
            width={24}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m23.645 9.245-.024-.02-11-9a1 1 0 0 0-1.266 0l-11 9a1 1 0 0 0 1.266 1.549l1.367-1.118V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9.656l1.367 1.118a1 1 0 1 0 1.29-1.53Zm-7.457 4.486L11.988 18l-4.2-4.27a2.8 2.8 0 0 1 0-3.92 2.7 2.7 0 0 1 4.2.43 2.7 2.7 0 0 1 4.2-.43 2.8 2.8 0 0 1 0 3.92Z"
                fill={fill}
            />
        </svg>
    )
}

function SvgNumber1(props) {
    return (
        <svg
            width={40}
            height={40}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#SvgNumber1_svg__a)">
                <rect width={40} height={40} rx={20} fill="#AC8243"/>
                <path
                    d="M25.342 28v-3.08H21.58V10.818h-2.618l-5.346 3.63L15.354 17l2.706-1.826v9.746h-3.762V28h11.044Z"
                    fill="#fff"
                />
            </g>
            <defs>
                <clipPath id="SvgNumber1_svg__a">
                    <rect width={40} height={40} rx={20} fill="#fff"/>
                </clipPath>
            </defs>
        </svg>
    )
}

function SvgNumber2(props) {
    return (
        <svg
            width={40}
            height={40}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#SvgNumber2_svg__a)">
                <rect width={40} height={40} rx={20} fill="#AC8243"/>
                <path
                    d="m20.502 24.92-1.562.022 4.378-4.796c1.276-1.408 1.914-2.42 1.914-4.444v-.396c0-2.244-1.452-4.752-5.632-4.752-3.828 0-5.632 1.87-5.632 5.566v.44h3.52c0-2.178.792-2.926 2.002-2.926h.22c1.166 0 2.002.77 2.002 2.332v.22c0 .946-.374 1.496-1.144 2.31l-6.6 7.282V28h11.264v-3.08h-4.73Z"
                    fill="#fff"
                />
            </g>
            <defs>
                <clipPath id="SvgNumber2_svg__a">
                    <rect width={40} height={40} rx={20} fill="#fff"/>
                </clipPath>
            </defs>
        </svg>
    )
}

function SvgNumber3(props) {
    return (
        <svg
            width={40}
            height={40}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#SvgNumber3_svg__a)">
                <rect width={40} height={40} rx={20} fill="#AC8243"/>
                <path
                    d="M17.378 22.5h-3.52v.286c0 3.52 1.892 5.5 5.742 5.5 4.114 0 5.742-2.706 5.742-4.884v-.418c0-1.892-.924-3.08-2.112-3.762 1.122-.66 2.002-1.848 2.002-3.674v-.418c0-2.068-1.452-4.576-5.632-4.576-3.828 0-5.632 1.87-5.632 5.566v.44h3.52c0-2.178.77-2.926 2.002-2.926h.22c1.166 0 2.002.77 2.002 1.914v.198c0 1.32-.748 1.958-2.024 1.958H17.4v3.08h2.354c1.276 0 2.068.66 2.068 2.002v.242c0 1.518-1.012 2.178-2.112 2.178h-.22c-1.188 0-2.112-.66-2.112-2.706Z"
                    fill="#fff"
                />
            </g>
            <defs>
                <clipPath id="SvgNumber3_svg__a">
                    <rect width={40} height={40} rx={20} fill="#fff"/>
                </clipPath>
            </defs>
        </svg>
    )
}

function SvgTicket2({code}) {
    return (
        <motion.svg
            animate={{rotate: -5}}
            transition={{duration: 1}}
            width={346}
            height={152}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"

        >
            <path
                d="M256.516 125.382H31.004V24.979h225.512M271.285 84.064v11.843M271.285 113.673v11.844M271.285 54.454v11.844M271.285 24.844v11.844"
                stroke="#202020"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M268.404 13H2v41.69a20.712 20.712 0 0 1 12.706 6.934 20.694 20.694 0 0 1 0 27.113A20.711 20.711 0 0 1 2 95.671v41.69h266.404"
                stroke="#202020"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x={236}
                y={20.661}
                width={74.957}
                height={135.855}
                rx={4}
                transform="rotate(-16 236 20.661)"
                fill="url(#tieroffticket_svg__a)"
            />
            <defs>
                <pattern
                    id="tieroffticket_svg__a"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                >
                    <use
                        xlinkHref="#tieroffticket_svg__b"
                        transform="matrix(.01353 0 0 .00746 -.007 0)"
                    />
                </pattern>
                <motion.image
                    animate={{rotate: 10, y: 10, x: 10}}
                    transition={{duration: 1}}
                    id="tieroffticket_svg__b"
                    width={75}
                    height={134}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAACGCAYAAACVOHeAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAZNSURBVHgB7Z1Ndts2EMcnbQ6g3IDddensugu8y87uCaycoPYJrJwg7QlqnaDWrrsgu+7iniC4QdVdu2pnzGE4hEiKlERgIOL3Hp7AD8XKXzMDDAhAAIopiuICFPEClIJCfcCXWyxbLBbLhl4dApHQLNYXemm5ZKEU7jG0cJrFusaXeyx9rvgELB7qZmFi1IpVgaIV+ELCXWExPbc6qIV7hAlQL5aEhTNQCnfdc+skcS4psXzYVam8gfb4VmGxrOFI4ZIWS4LCGajdtei59eA4dzZiSQ6Ic+shwp2lWJJTxrmzF8vnmDg3O7EkI+Pc+1mLJeE81EB3nNtmsVoQce4nqDMIm8XqATX7DepG4e4byPRhRP0xi9UBB/8FH1KD6LJY3dyIOvW9IIvVjRH151GMLFYL7IIFH7oqFcpitSPTIltVsljtvBH1TVXJ/SwP7pB+qY7RBb9qlC1rF+mCG3khi7XLlag3xvKzWAKRE1ZYeT2L1cSI+s4AYBariXTBjX8xi9XEiPrOs8csFsPDzY3E2b8ni1XT64JEFqvGiHrr4/8sFnQnzj5ZrJLWxNkni1XSmjj7zD6R9hLnLbrgq657s2U1XfBT341ZrJ7E2WfWYu1LnH3mbllG1PdOdJu7WHt77ZK5iyWD+95Ju7MVixPniqchc03nbFnSBT8NecOcxTKiPmje/CzFGpo4+8zVsgYlzj5zFWtUl6FijrOVCxiYOPvM0bIGJ84+L+GMQSOiBxAL7/TgxNnnrMTiVo4G8uiVZhkv9rzFwgiSF4uth6Zg38J+cSSjV4glK9ZAkbZcGm/lc7/ASJJsDVEoEmkFuyKRCLTe5nmZXJflkNB4aQsjSW0lK4lDq/KX3iWL5b2beJ10MmJx/4hWPFyI0w7LOxdgMTmRRD+LhfoITaEo5rwOJRSRwup7cr3P0Fzidoci/QyBSaE1pBhViGNyuweIgGo35FZvKU7dxRKK0LxjSAGl+1XdA2rtVhARzZZFW6vIyWUriIxKsdiqluLUO1CAVsu6F/VNyO5BH1rFMqIevIvQhTqx+HlewYdOi1URGi3LiPrg8fEQaBRLzsIbNZI5NRrFkvnfEyhClVjcZahwh4w5TYk2yypE3YEy8jTJEWSxRqBZrDFPaoKgTSwn6urEUjdEgw3if+LwlaYWUaMbyr7VBShCo1hyssY1KEKjWDLFuQJFaHXDKk4VPNlDBerE4oC+FqfuQQla+1lywM9osS6VYvGEDmldH0ABmnvwK6hj1wX/TENUvgWlbJHFYvEvVt/yqR/w2OHpPyESasUiUJg/UCDqmH7Pp65jCpbCqAM9M3Ti+AFd8hYioNqyCLSif9Ca6MGF3P7kLZ6ja6OmZh9LapPZaI5WIU47KCeLBHmwkeI0SeqD3XiXLJRTkRxMiHo3lJBLYnlEF/wbyqBfuWWB5QVe+x0mJMlhZZ71dwnNwD/5Y7OUx+Cpw1qIYwsTk7JYRtSfpo5XRMpiHbRm8BjOxbKCdB2SFKtljXOQORGpWpbsZ1kIRKpiGVFfQyCSWxXGv4/zmQ9HrXE+lhQty4h60MluKYol41XQUYekxOKRB/mUOltWD0bUbeh5EKmJJV0wWCtYkYxYPJZlxCkLgUnJsoyoB0mcfVISSybOwV2QSEmsg7ZxOiWpLCg30Fx7GGUxQSqWFSVx9klFLCPqUeIVkcJWBdESZ58ULMuIetRVYimItfMLlrHQvq9DAc3E2UJEtFuWEfXgibOPdrGiJs4+L8UOZ/SqZlsADYmzD23cQ2nEio9v8UOSqVOrQ8E0pumP3lV7akgsXwz6Rpdc6Bu2ULqADfyB5cLy6C5IPHdKOfdaQvkBi577KSerhJs0P8PP9BfU+eDrWPmgZKcHzz1mA2Vw7VuV5aCMI+tTxzn+8j5Wfwf5DhTQm+6IXw+5gWaw9XFQCneSOId/9leoN+55wH9PxcY9g3NDbp0o6BooB+L6VppaOCLO4d+ijaILPrzU0kIfnEiPiHMWaovbG3e8xFmNCxIH7/nH3zaV6j9IVkcW58c5w4Xuc7A/zkUfEe3i5EM0x8Y5fDtZVSX4j6GmbQ9h0vGsA+IcCScXNKlaUB508G9EnCPI2i5BEdFGSjnOLaEUrq0/F20/0i5UDCu3xDkHZZfBQaYbjnMq+R94fRPf/zAuoQAAAABJRU5ErkJggg=="
                />
            </defs>
            <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="black">{code}</text>

        </motion.svg>
    )
}

function SvgTailDown2(props) {
    return (
        <svg
            width={12}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M6 1v10M9.5 7.5 6 11 2.5 7.5"
                stroke="#095191"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgTailDown3(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12.707 22.707 20.414 15 19 13.586l-6 6V2a1 1 0 1 0-2 0v17.586l-6-6L3.586 15l7.707 7.707a.999.999 0 0 0 1.414 0Z"
                fill="#fff"
            />
        </svg>
    )
}

function SvgTailLeft1(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1.293 11.293 9 3.586 10.414 5l-6 6H22a1 1 0 1 1 0 2H4.414l6 6L9 20.414l-7.707-7.707a.999.999 0 0 1 0-1.414Z"
                fill="#AC8243"
            />
        </svg>
    )
}

function TailLeftHeader() {
    return (
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.07836 7.41078L7.50086 0.988281L8.67919 2.16661L3.67919 7.16661H18.3342C18.795 7.16661 19.1675 7.53995 19.1675 7.99995C19.1675 8.45995 18.795 8.83328 18.3342 8.83328H3.67919L8.67919 13.8333L7.50086 15.0116L1.07836 8.58911C0.752526 8.26328 0.752526 7.73661 1.07836 7.41078Z"
                fill="#AC8243"/>
        </svg>
    )
}

function SvgTailRight2(props) {
    return (
        <svg
            width={45}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                opacity={0.5}
                stroke="#fff"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M43 16H3M12 25.333 2.667 16 12 6.667"/>
            </g>
        </svg>
    )
}

function VectorTailDown() {
    return (
        <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L9 9L17 1" stroke="#AC8243" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}


function SvgTailRight1(props) {
    return (
        <svg
            width={45}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                opacity={0.5}
                stroke="#fff"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M2 16h40M33 6.667 42.333 16 33 25.333"/>
            </g>
        </svg>
    )
}

function SvgTap(props) {
    return (
        <svg
            width={105}
            height={105}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                clipPath="url(#tap-01_1_svg__a)"
                stroke="#fff"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path
                    d="m46.83 62.077 6.535 6.534M63.53 41.505l-14.523 9.681-9.802-9.801a4.62 4.62 0 1 0-6.534 6.534l14.158 14.158-4.357 4.356a3.08 3.08 0 0 0 0 4.357l8.713 8.712c3.812 3.812 12.047 1.157 16.336 5.446l19.603-19.604-15.082-22.179a6.158 6.158 0 0 0-8.511-1.66Z"/>
                <path
                    d="M32.67 58.811a15.337 15.337 0 0 1-8.71-4.357c-6.016-6.015-6.016-15.767 0-21.782 6.014-6.015 15.765-6.015 21.78 0a15.333 15.333 0 0 1 4.358 8.714"/>
            </g>
            <defs>
                <clipPath id="tap-01_1_svg__a">
                    <path
                        fill="#fff"
                        transform="rotate(-45 63.102 26.138)"
                        d="M0 0h73.929v73.929H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

function SvgTheater1(props) {
    return (
        <svg
            width={48}
            height={48}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M36 26h3M9 16h3M20 16h3M20.793 40.364A13.987 13.987 0 0 0 46.001 32V15.321a42.256 42.256 0 0 0-11-2.321"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2 22V4.441A41.843 41.843 0 0 1 16 2c4.772.01 9.507.835 14 2.441V22a14 14 0 0 1-28 0v0Z"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 26a4 4 0 1 1-8 0h8ZM27.758 37.757a6 6 0 0 1 8.486 0"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgTheater2(props) {
    return (
        <svg
            width={21}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#theater_2_svg__a)" fill="#AC8243">
                <path
                    d="M13.278 1.637a18.14 18.14 0 0 0-12.223 0 .833.833 0 0 0-.555.786v8.15a6.667 6.667 0 0 0 13.333 0v-8.15a.833.833 0 0 0-.555-.786ZM3 7.24a.833.833 0 0 1 .833-.833h.834a.833.833 0 0 1 0 1.666h-.834A.833.833 0 0 1 3 7.24Zm4.167 7.5a2.5 2.5 0 0 1-2.5-2.5h5a2.5 2.5 0 0 1-2.5 2.5ZM10.5 8.072h-.833a.833.833 0 1 1 0-1.666h.833a.833.833 0 0 1 0 1.666Z"/>
                <path
                    d="M19.945 4.966a18.394 18.394 0 0 0-4.445-.978v6.583a.833.833 0 0 1 .834-.833h.833a.833.833 0 1 1 0 1.667h-.834a.833.833 0 0 1-.833-.834c0 1.806-.59 3.561-1.68 5h.014a2.5 2.5 0 0 1 2.5 2.5H10.73a8.22 8.22 0 0 1-1.564.584 6.66 6.66 0 0 0 11.334-4.75V5.75a.833.833 0 0 0-.555-.785Z"/>
            </g>
            <defs>
                <clipPath id="theater_2_svg__a">
                    <path fill="#fff" transform="translate(.5 .571)" d="M0 0h20v20H0z"/>
                </clipPath>
            </defs>
        </svg>
    )
}

function SvgTheaterCurtains1(fill) {
    return (
        <svg
            width={25}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.545 21.7A1 1 0 0 0 17.5 23h5a1 1 0 0 0 1-1v-7h-4.86l-2.095 6.7ZM6.36 15H1.5v7a1 1 0 0 0 1 1h5a1 1 0 0 0 .955-1.3L6.36 15ZM22.5 1h-20a1 1 0 0 0-1 1v11h5.688a20.048 20.048 0 0 0 3.27-10h4.084a20.048 20.048 0 0 0 3.27 10H23.5V2a1 1 0 0 0-1-1Z"
                fill={fill}
            />
        </svg>
    )
}

function SvgTicket({code}) {
    return (
        <svg

            width={308}
            height={127}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M256.111 113.701H30.6V13.298H256.11M270.881 72.383v11.844M270.881 101.993v11.844M270.881 42.773v11.844M270.881 13.163v11.844"
                stroke="#202020"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M288.655 63.5a20.7 20.7 0 0 1 5.065-13.558 20.718 20.718 0 0 1 12.709-6.932V1.32H1.596v41.69a20.712 20.712 0 0 1 12.706 6.933 20.694 20.694 0 0 1 0 27.114A20.712 20.712 0 0 1 1.596 83.99v41.69h304.833V83.99a20.718 20.718 0 0 1-12.709-6.933 20.7 20.7 0 0 1-5.065-13.557Z"
                stroke="#202020"
                strokeWidth={3}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="black">{code}</text>
        </svg>
    )
}

function SvgTicket1(props) {
    return (
        <svg
            width={48}
            height={48}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M42 24a5 5 0 0 1 4-4.9V8H2v11.1a5 5 0 0 1 0 9.8V40h44V28.9a5 5 0 0 1-4-4.9v0Z"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31 32H12V16h19M36 22v4M36 13v4M36 31v4"
                stroke="#AC8243"
                strokeWidth={2}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

function SvgTriangleIconDown(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M17 7H7a1.002 1.002 0 0 0-.848 1.53l5 8a1 1 0 0 0 1.696 0l5-8A1 1 0 0 0 17 7Z"
                fill="#fff"
            />
        </svg>
    )
}

function SvgTriangleSmDown1(props) {
    return (
        <svg
            width={32}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M22.667 9.333H9.334a1.334 1.334 0 0 0-1.13 2.04l6.666 10.667a1.335 1.335 0 0 0 2.261 0l6.667-10.667a1.333 1.333 0 0 0-1.131-2.04Z"
                fill="#AC8243"
            />
        </svg>
    )
}

function SvgVideoIcon(fill) {
    return (
        <svg
            width={25}
            height={18}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.5 6V3a3 3 0 0 0-3-3h-12a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-3l6 3V3l-6 3ZM5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
                fill={fill}
            />
        </svg>
    )
}

function PlayIconImg() {
    return (
        <svg width="10" height="14" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.6544 7.85865L1.98776 0.150316C1.74899 -0.00693404 1.44176 -0.0223507 1.18976 0.111774C0.936209 0.245899 0.77832 0.507212 0.77832 0.791649V16.2083C0.77832 16.4927 0.936209 16.7541 1.18899 16.8882C1.3041 16.9491 1.4301 16.9791 1.5561 16.9791C1.70699 16.9791 1.85788 16.9352 1.98776 16.8496L13.6544 9.14131C13.8707 8.99794 14.0005 8.75744 14.0005 8.49998C14.0005 8.24252 13.8707 8.00202 13.6544 7.85865Z"
                fill="white"/>
        </svg>

    )
}

function SvgPlayIcon() {
    return (
        <svg width="94" height="121" viewBox="0 0 94 121" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M91.1947 55.9585L9.31974 1.37518C7.64403 0.261679 5.48799 0.152513 3.71949 1.10226C1.94007 2.05201 0.832031 3.90239 0.832031 5.91651V115.083C0.832031 117.097 1.94007 118.948 3.71403 119.897C4.52186 120.329 5.40611 120.542 6.29036 120.542C7.34928 120.542 8.4082 120.23 9.31974 119.625L91.1947 65.0412C92.7122 64.0259 93.6237 62.3229 93.6237 60.4999C93.6237 58.6768 92.7122 56.9738 91.1947 55.9585Z"
                fill="white"/>
        </svg>
    );
}

export {
    QuestionSvg,
    CarouselArrowRight,
    CarouselArrowLeft,
    SwiperArrowRight,
    SwiperArrowLeft,
    Alarm,
    ArrowCatUp,
    SvgArrowCatDown,
    ArrowDown,
    ArrowDownDropdown,
    SvgBMeeting,
    SvgCalendarGrid,
    SvgDiagTopRight,
    SvgDropDownSelected,
    SvgEventTicket,
    SvgEventTicketmb,
    SvgEventTicketSm,
    SvgFrame,
    SvgFurnishedProperty,
    SvgHamburgerIcon,
    SvgInfo,
    SvgLeftArrow,
    SvgLock,
    SvgLogout,
    SvgMaskMob,
    SvgMasks,
    SvgMaskTablet,
    SvgMinimalUp,
    SvgRightArrow,
    SvgSearchIcon,
    SvgShop,
    SvgSimpleRemove1,
    SvgSimpleRemove2,
    SvgStar,
    SvgStarMobile,
    SvgSucces,
    SvgNumber1,
    SvgNumber2,
    SvgNumber3,
    SvgTicket2,
    SvgTailDown2,
    SvgTailDown3,
    SvgTailLeft1,
    SvgTailRight2,
    SvgTailRight1,
    SvgTap,
    SvgTheater1,
    SvgTheater2,
    SvgTheaterCurtains1,
    SvgTicket,
    SvgTicket1,
    SvgTriangleIconDown,
    SvgTriangleSmDown1,
    SvgVideoIcon,
    SvgArrowSmLeft1,
    SvgGroup,
    SvgPlayIcon,
    VectorTailDown,
    TailLeftHeader,
    PlayIconImg
}
